<template>
    <v-system-bar
        v-if="$impersonate.state.isActive"
        height="36"
        app
        color="yellow"
        class="d-flex px-6 justify-space-between"
    >
        <div>
            <span class="mr-2">{{ $t('impersonate_bar.title') }}</span>
            <v-chip class="mr-8" small>{{ username }}</v-chip>
            <span class="mr-2">{{ $t('impersonate_bar.role') }}</span>
            <v-chip class="mr-8" small>{{ $t(`roles.${role}`) }}</v-chip>
            <v-btn small color="primary" @click="jumpToFrontend">{{
                $t('impersonate_bar.login')
            }}</v-btn>
        </div>

        <v-btn :loading="$impersonate.state.isLoading" small @click="exit">{{
            $t('impersonate_bar.exit')
        }}</v-btn>
    </v-system-bar>
</template>
<style lang="scss" scoped>
#impersonate-bar {
    z-index: 90000;
}
</style>
<script>
import authType from '@/store/type/authType'

export default {
    data() {
        return {}
    },
    computed: {
        username() {
            return this.$store.getters[authType.getters.GET_EMAIL]
        },
        role() {
            if (this.$store.getters[authType.getters.IS_RESTAURANT_ADMIN]) {
                return 'ROLE_RESTAURANT'
            }
            if (this.$store.getters[authType.getters.IS_COMPANY_ADMIN]) {
                return 'ROLE_COMPANY'
            }
            if (this.$store.getters[authType.getters.IS_SUPER_ADMIN]) {
                return 'ROLE_ADMIN'
            }
            return 'ROLE_USER'
        },
    },
    methods: {
        async jumpToFrontend() {
            this.$impersonate.loginToFrontend()
        },
        async exit() {
            this.$impersonate.frontendExit()
        },
    },
}
</script>
